import React, { useState } from 'react';
import ReactTable from 'react-table'
import { Button } from "../buttons";
import axios from "axios";
import {API} from "../../config";
import {isAuthenticated} from "../../store/action/auth";
import numeral from 'numeral';

const AdminUserTable = props => {
    const { token } = isAuthenticated();

    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 40,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'User Id',
        accessor: 'id',
    },{
        Header: 'Nama Depan',
        maxWidth: 100,
        accessor: 'firstName',
    },{
        Header: 'Nama Belakang',
        maxWidth: 100,
        accessor: 'lastName',
    },{
        Header: 'Email',
        accessor: 'email',
    },{
        Header: 'Nomor Telepon',
        accessor: 'phone',
    },{
        Header: 'Organisasi',
        accessor: 'organizationName',
    },{
        Header: 'Kunci API',
        accessor: 'totalKeys',
        Cell: ({row,original}) => keysCell(original)
    },{
        Header: 'Tipe Wallet',
        accessor: 'walletType',
        Cell: ({row,original}) => walletCell(original)
    },{
        Header: 'Saldo',
        accessor: 'walletBalance',
        Cell: ({row,original}) => balanceCell(original)
    },{
        Header: 'Aksi',
        maxWidth: 100,
        accessor: 'action',
        Cell: ({row,original}) => actionCell(original)
    }];

    const keysCell = (og) => {
        return (
            <div>
                {
                    og.keys.map(i => (
                        <div className={i.status === 'active' ? "text-success bold" : null}>
                            {i.type}
                        </div>
                    ))
                }
            </div>
        )
    }

    const actionCell = (og) => {
        return (
            <div>
                <Button className="badge badge-success border-success" onClick={() => window.location.href = `/admin/users/${og.id}`}>
                    Detail
                </Button>
            </div>

        )
    };

    const balanceCell = (og) => {
        return (
            <div>
                Rp. {numeral(og.walletBalance).format("0,0")}
            </div>

        )
    };

    const walletCell = (og) => {
        if (og.walletType === 'postpaid') {
            return (
                <div className="badge badge-primary">
                    postpaid
                </div>
            )
        } else if (og.walletType === 'prepaid') {
            return (
                <div className="badge badge-warning">
                    prepaid
                </div>
            )
        } else {
            return (
                <div className="badge badge-danger">
                    unknown
                </div>
            )
        }
        
    };

    const addCatalog = async (id) => {
        try {
            let data = { user_id:id };
            const res = await axios.post(`${API}/v1/admin/catalogs`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                alert(res.data.message);
                window.location.reload()
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            console.log (e);
            return alert(e.message)
        }
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={50}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminUserTable;
